import React from "react"; 
import { NavLink } from "react-router-dom";

export default function CasinoSuperskokSignIn(props) { 

    return (
        <div className="casino-superskok-section">
            <h2>Moji podaci</h2>    
            <div className="my-data sign-in">
                <span className="place inactive">
                    <span className="image">
                        <span className="red-line"></span>
                        <span className="gray-line"></span>
                    </span>                     
                </span>
                <span className="points inactive">
                    <span className="image">
                        <span className="red-line"></span>
                        <span className="gray-line"></span>
                    </span>
                </span>
                <span className="points-total inactive">
                    <span className="image">
                        <span className="red-line"></span>
                        <span className="gray-line"></span>
                    </span>                  
                </span>
                {!props.igracJeLogiran &&
                <span className="log-in">
                    <div className="text">Prijavi se i iskušaj u SuperSkok utrci!</div>
                    <div className="actions">
                        {!casino.config.fromNativeApp && <NavLink  to="/login" className="login-btn">Prijavi se i zaigraj</NavLink> }
                        {casino.config.fromNativeApp && <button className="login-btn" onClick={() => location.href='https://m.supersport.hr/registracija'}>Prijavi se i zaigraj</button>}
                        <button className="registration-btn" onClick={() => location.href='https://m.supersport.hr/registracija'}>Registriraj se</button>
                    </div>
                </span>}

                {props.igracJeLogiran && props.resultsLoaded &&
                <span className="log-in">
                    <div className="text small">
                        <span className="icon yellow"></span>
                        Trebaš odigrati da bi sudjelovao! Kreni sada!
                    </div>
                    <div className="actions">
                        <NavLink  to="/" className="play-now-btn">Zaigraj</NavLink>
                    </div>
                </span>}

                {props.igracJeLogiran && props.resultsLoaded && !props.isFinished &&
                <span className="log-in">
                    <div className="text small">
                        <span className="icon red"></span>
                        Nažalost, ispao si iz Superskok Utrke! Treniraj naše <span style={{color:'#aa0d19'}}> Casino utrke</span>!
                    </div>
                </span>}
                {props.igracJeLogiran && props.resultsLoaded && props.isFinished &&
                <span className="log-in">
                    <div className="text">
                        <span className="icon yellow"></span>
                        <span style={{color:'#aa0d19'}}> Superskok utrka</span> je završena!
                    </div>
                </span>}
            </div> 
            <div className="divider"></div>      
        </div>
    );
}